import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMeldooWebReportDetails } from 'actions/MeldooWeb';
import IntlMessages from 'util/IntlMessages';
import { withRouter } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import Maps from 'containers/Maps';
import Moment from 'moment';
import { Alert } from 'reactstrap';
import { Card, CardBody, CardHeader } from 'reactstrap';
import User from 'components/User';
import WorkflowItem from './Component/WorkflowItem';
import Lightbox from 'react-images';

class ReportDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lightboxIsOpen: false,
			currentImage: 0,
			lightboxImageZoom: false
		};
	}

	//	UNSAFE_componentWillMount() {
	componentDidMount() {
		this.props.getMeldooWebReportDetails(this.props.reportId);
	}

	_lightboxOnPrevious = () => {
		const nextImage = this.state.currentImage - 1;
		this.setState({ currentImage: nextImage });
		this._imageGallery.slideToIndex(nextImage);
	};

	_lightboxOnNext = () => {
		const nextImage = this.state.currentImage + 1;
		this.setState({ currentImage: nextImage });
		this._imageGallery.slideToIndex(nextImage);
	};

	// <Alert className="alert-addon-card border overflow-hidden text-white py-2 custom-grey" isOpen={status === 6}>
	// 	<span className="icon-addon alert-addon">
	// 		<i className="zmdi zmdi-flag zmdi-hc-fw zmdi-hc-lg" />
	// 	</span>
	// 	<span className="d-inline-block status-alert-text">
	// 		<IntlMessages id="report.status.inProcess" />
	// 		<User user={inProcessBy} className="text-white" />
	// 	</span>
	// </Alert>

	render() {
		const { reportId, images, type, description, insertDate, status, workflow, inProcessBy } = this.props.reportDetails;
		const { colors } = this.props.settings;
		//console.log('reportDetails: ', this.props.reportDetails);
		return (
			<div className="row w-100 m-0 align-items-start">
				<div className="col-12 mb-3">
					<div>
						<Breadcrumb className="mb-0 navigation-style" tag="nav">
							<BreadcrumbItem
								tag="span"
								className="pointer"
								onClick={() => this.props.history.push(`/meldoo-web/${this.props.organisationKey}`)}
							>
								<IntlMessages id="meldooWeb.reportCollection.title" />
							</BreadcrumbItem>
							<BreadcrumbItem active tag="span">
								<IntlMessages id="meldooWeb.reportDetails.title" />
								{` ${reportId}`}
							</BreadcrumbItem>
						</Breadcrumb>
					</div>
				</div>
				<div className="col-12">
					<Alert className="alert-addon-card border overflow-hidden py-2 w-100 custom-success" isOpen={status === 7}>
						<span className="icon-addon alert-addon">
							<i className="zmdi zmdi-check zmdi-hc-fw zmdi-hc-2x" />
						</span>
						<span className="d-inline-block status-alert-text">
							<IntlMessages id="report.status.completed" />
						</span>
					</Alert>
				</div>
				<div className="col-lg-6 col-md-12">
					<Card>
						<CardHeader className="custom-main">
							<i className="zmdi zmdi-pin zmdi-hc-lg ml-auto" /> <IntlMessages id="meldooWeb.reportDetails.location" />
						</CardHeader>
						<CardBody className="p-0">
							<Maps
								center={this.props.reportDetails.latlng}
								data={[this.props.reportDetails]}
								types={this.props.settings.types}
								dimensions="4by3"
							/>
						</CardBody>
					</Card>
				</div>
				<div className="col-lg-6 col-md-12">
					<Card className="jr-card-full-height">
						<CardHeader className="custom-main">
							<i className="zmdi zmdi-info-outline zmdi-hc-lg ml-auto" /> <IntlMessages id="Meldungsdaten" />
						</CardHeader>
						<CardBody>
							<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
								<div>
									<strong>
										<IntlMessages id="meldooWeb.reportDetails.props.reportId" />:
									</strong>
								</div>
								<div>{reportId}</div>
							</div>
							<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
								<div>
									<strong>
										<IntlMessages id="meldooWeb.reportDetails.props.type" />:
									</strong>
								</div>
								<div>{type.name}</div>
							</div>
							{
								//<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
								// <div>
								// 	<strong>
								// 		<IntlMessages id="meldooWeb.reportDetails.props.insertDate" />:
								// 	</strong>
								// </div>
								// <div>{Moment(insertDate).format('DD.MM.YYYY HH:mm')}</div>
								//</div>
							}
							<div className="border-bottom pb-2 mb-2">
								<div className="mb-2">
									<strong>
										<IntlMessages id="meldooWeb.reportDetails.props.description" />:
									</strong>
								</div>
								<div>{description}</div>
							</div>
							<div className="">
								<div className="mb-2">
									<strong>
										<IntlMessages id="meldooWeb.reportDetails.props.images" />:
									</strong>
								</div>
								<div className="justify-content-start">
									<div className="slg row g-ul m-0">
										{images.map((image, index) => (
											<div key={index}>
												<div
													className="grid pointer"
													style={{ height: 100, width: 100, marginRight: 10 }}
													onClick={() => this.setState({ currentImage: index, lightboxIsOpen: true })}
												>
													<img src={image.thumbnail} alt={image.title} />
												</div>
											</div>
										))}
									</div>
									<Lightbox
										images={images.map(value => {
											return {
												src: value.url,
												srcSet: [`${value.url} 1024w`]
											};
										})}
										currentImage={this.state.currentImage}
										isOpen={this.state.lightboxIsOpen}
										onClickPrev={this._lightboxOnPrevious}
										onClickNext={this._lightboxOnNext}
										onClose={() =>
											this.setState({
												lightboxIsOpen: false,
												lightboxImageZoom: false
											})
										}
										showImageCount={false}
										//onClickImage={() => console.log('click')}
										backdropClosesModal
										width={2048}
									/>
								</div>
							</div>
						</CardBody>
					</Card>
				</div>
				<div className="col-12">
					<div className="timeline-section clearfix animated slideInUpTiny animation-duration-3">
						{workflow.map(item => (
							<WorkflowItem key={item.id} item={item} />
						))}
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps({ meldooWeb }) {
	const { reportDetails, settings } = meldooWeb;
	return { reportDetails, settings };
}

export default connect(
	mapStateToProps,
	{ getMeldooWebReportDetails }
)(withRouter(ReportDetails));



// WEBPACK FOOTER //
// ./containers/MeldooWeb/Pages/ReportDetails/index.js